import * as React from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";

import "../data-source/CreateDataSource.css";
import { Checkbox, FormControlLabel, Paper } from "@mui/material";
import Card, { CardBody, CardFooter } from "../../../components/bootstrap/Card";
import FormGroup from "../../../components/bootstrap/forms/FormGroup";
import Input from "../../../components/bootstrap/forms/Input";
import Button from "../../../components/bootstrap/Button";
import Breadcrumb from "../../../components/bootstrap/Breadcrumb";
import Checks from "../../../components/bootstrap/forms/Checks";
import CustomScrollbar from "../../../components/bootstrap/CustomScrollbar";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../../components/ToastComponent";
import { capitalizeAllLetter } from "../common-component/CapitalizeFirstLetter";
import ToastComponent from "../../../components/ToastComponent";

export default function CreateRole() {
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const vyu_service_url = process.env.REACT_APP_VYU_SERVICE_URL;
  const form = useForm<FormValues>();
  const { handleSubmit } = form;
  const [users, setUsers] = React.useState<any[]>([]);
  const [usersDuplicate, setUsersDuplicate] = React.useState<any[]>([]);
  const [selectedUsers, setSelectedUsers] = React.useState<any[]>([]);
  const [show, setShow] = React.useState(false);
  const [disabled, setDisabled] = React.useState(true);
  const [successMessage, setSuccessMessage] = React.useState<string>("");
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const [searchInput, setSearchInput] = React.useState<string>("");
  const [formData, setFormData] = React.useState<FormValues>({
    roleName: "",
    users: [],
  });

  type FormValues = {
    roleName: string;
    users: any[];
  };

  const location = useLocation();

  // Load form data on mount
  React.useEffect(() => {
    const savedFormData = localStorage.getItem("rolesFormData");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }
  }, []);

  // Save form data on change
  React.useEffect(() => {
    localStorage.setItem("rolesFormData", JSON.stringify(formData));
  }, [formData]);

  // Clear localStorage if leaving roles section
  React.useEffect(() => {
    return () => {
      if (!location.pathname.startsWith("/roles")) {
        localStorage.removeItem("rolesFormData");
      }
    };
  }, [location.pathname]);

  const addOrRemoveUsersToGroupOnCheckboxChange = (event: any) => {
    const { checked, value } = event.currentTarget;
    setSelectedUsers((prev: any) =>
      checked ? [...prev, value] : prev.filter((val: any) => val !== value)
    );
  };
  const getAllUsers = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${vyu_api_url}/user/allUser`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setUsers(data);
        setUsersDuplicate(data);
      }
    } catch (e) {}
  };
  React.useEffect(() => {
    getAllUsers();
  }, []);

  const saveRole = async () => {
    const token = localStorage.getItem("token");
    const formDataObject = {
      roleName: capitalizeAllLetter(formData.roleName),
      userIdList: selectedUsers.map((e) => Number(e)),
    };

    try {
      const response = await fetch(`${vyu_api_url}/role/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },

        body: JSON.stringify(formDataObject),
      });
      if (response.ok) {
        setSuccessMessage("Role created successfully!");
        handleSuccess("Role created successfully!");
      } else {
        const data = await response.json();
        handleError(data.message || "Failed to create role!");
      }
    } catch (error) {
      console.error("Error creating widget:", error);
      setErrorMessage("An error occurred while creating role");
    }
    handleFullReset();
  };
  const handleWarning = (message: string) => {
    showWarningToast(message);
  };
  const handleSuccess = (message: string) => {
    showSuccessToast(message);
  };
  const handleError = (message: string) => {
    showErrorToast(message);
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
    if (formData.roleName !== "") {
      setDisabled(false);
    }
  };
  const handleReset = () => {
    setFormData({
      roleName: "",
      users: [],
    });
    setDisabled(true);
    setShow(false);
  };
  const handleFullReset = () => {
    setFormData({
      roleName: "",
      users: [],
    });
    setDisabled(true);
    setShow(false);
  };
  const onSubmit = () => {
    saveRole();
  };
  const handleCheckBox = async () => {
    try {
      setDisabled(false);
      setShow((prev) => !prev);
    } catch (e) {
      console.error(e);
    }
  };

  function handleSearchInput1Change(
    event: React.ChangeEvent<HTMLInputElement>
  ): void {
    const val = event.target.value;
    setSearchInput(val);
    let allUsers = usersDuplicate;
    let filteredUsers = allUsers.filter(
      (item) =>
        item.firstName.toLowerCase().startsWith(val.toLowerCase()) ||
        item.lastName.toLowerCase().startsWith(val.toLowerCase())
    );
    setUsers(filteredUsers);
  }
  const inputStyle =
    "form-control block w-full px-3 py-2 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded-md transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none";
  const smallRadius = { borderRadius: "4px", borderColor: "#E0E0E0" };
  return (
    <>
      {/* <Breadcrumb
        list={[
          { title: "Roles", to: "" },
          { title: "Create Roles", to: "" },
        ]}
      /> */}
      <div className="column">
        <div className="col-lg-12">
          <Card stretch style={{ borderRadius: "4px" }}>
            <CardBody>
              {/* <h1 className="font-bold  text-3xl pb-2 italic ml-3">
                <span className="text-3xl font-light"></span>Create Roles
              </h1> */}
              <div className="col-lg-6 mb-4">
                <FormGroup label="Role Name">
                  <Input
                    // className="shadow-md italic w-full h-10 mb-6"
                    // fullWidth
                    // variant="outlined"
                    id="roleName"
                    name="roleName"
                    style={smallRadius}
                    className={inputStyle}
                    placeholder="Enter name of the Role"
                    value={formData.roleName}
                    onChange={handleChange}
                  />
                </FormGroup>
              </div>

              <div className="col-lg-6 mb-4">
                <FormGroup label="Add users to role?">
                  <Checks
                    //disabled={disabled}
                    className="rounded-lg bg-black"
                    onChange={handleCheckBox}
                    checked={show}
                    type="checkbox"
                    aria-label="pr"
                  />
                </FormGroup>
                {show && (
                  <Card stretch style={{ borderRadius: "4px" }}>
                    <CardBody>
                      <>
                        <div className="mb-1 mt-3">
                          <input
                            type="text"
                            // className="form-control"
                            style={smallRadius}
                            className={inputStyle}
                            onChange={handleSearchInput1Change}
                            placeholder="Search..."
                            name="search"
                          />
                        </div>
                        <CustomScrollbar height="200px">
                          {users.map((item) => (
                            <div className="m-2" key={item.userId}>
                              <input
                                value={item.userId}
                                type="checkbox"
                                className="custom-checkbox p-1"
                                defaultChecked={selectedUsers.some(
                                  (val) => val === item.userId
                                )}
                                onChange={
                                  addOrRemoveUsersToGroupOnCheckboxChange
                                }
                              />
                              <label className="m-2">
                                {item.firstName + " " + item.lastName}
                              </label>
                            </div>
                          ))}
                        </CustomScrollbar>
                      </>
                    </CardBody>
                  </Card>
                )}
              </div>
            </CardBody>

            <CardFooter>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "8px",
                }}
              >
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                    // border: "1px solid black",
                  }}
                >
                  <Button
                    isLight={true}
                    color="primary"
                    // className="basis-1/2 m-1 text-black italic bg-violet-200 hover:bg-violet-100 font-medium rounded-lg text-sm px-5 py-2 dark:bg-violet-200 dark:hover:bg-violet-100"
                    className="submit-reset"
                    style={{ border: "1px solid #d0d5dd" }}
                    type="button"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                  <Button
                    isLight={true}
                    color="primary"
                    // className="m-1"
                    className="submit-button"
                    onClick={handleSubmit(onSubmit)}
                    type="submit" // Correct way to handle form submission
                  >
                    Submit
                  </Button>
                </form>
              </div>
            </CardFooter>
          </Card>
          <ToastComponent />
        </div>
      </div>
    </>
  );
}
